import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import DashboardCard, { EmptyState } from './DashboardCard';
import { fmtDateTime, methodLabels } from './formatters';

/** Latest successful activations matching the filters (not limited to the date range). */
export default function RecentActivationsTable({ rows = [], action, sx }) {
  return (
    <DashboardCard title="Recent activations" action={action} flush sx={sx}>
      {rows.length === 0 ? (
        <EmptyState />
      ) : (
        <TableContainer>
          <Table size="small" sx={{ minWidth: 600, '& td, & th': { py: 1.25 }, '& tr > :first-of-type': { pl: 3 }, '& tr > :last-child': { pr: 3 } }}>
            <TableHead>
              <TableRow>
                <TableCell>When</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Product · option</TableCell>
                <TableCell>Machine</TableCell>
                <TableCell>Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} hover>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDateTime(r.activatedAt)}</TableCell>
                  <TableCell>{r.company}</TableCell>
                  <TableCell>
                    {r.product}
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{r.opt}</Typography>
                  </TableCell>
                  <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>
                    {r.machine || '—'}
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontFamily: 'inherit' }}>
                      {methodLabels[r.method] ?? r.method}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={r.isRefresh ? 'Refresh' : 'New'}
                      sx={r.isRefresh ? { bgcolor: '#E0F2F1', color: '#00594F' } : { bgcolor: '#E3EAF7', color: '#1E3A8A' }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DashboardCard>
  );
}
